// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__OhfH+","footerHeart":"Footer_footerHeart__kR3H5"};